import { CustomNode } from '../../../types';
import { sendEmbeddedIcon } from '../../../icons';

const DEFAULT_ICON = sendEmbeddedIcon;

export const sendEmbeddedConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
